<template>
    <div class="navbar flex align-cen">
          <hamburger id="hamburger-container"  :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
          <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Hamburger from '@/components/Hamburger'
import Breadcrumb from '@/components/Breadcrumb'

export default {
      components: {
       Breadcrumb,
       Hamburger,
  },
   computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device'
    ])
  },
    methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
  }
}
</script>
<style>
    
</style>